<template>
  <div class="p-6 bg-white shadow rounded-lg">
    <div class="flex flex-wrap gap-4 mb-4">
      <el-date-picker
        v-model="range.start_time"
        type="datetime"
        :picker-options="pickerOptions"
        format="yyyy/MM/dd"
        size="small"
        class="p-2 border rounded-md shadow-sm"
        placeholder="Эхлэх огноог сонгоно уу"
      />
      <el-date-picker
        v-model="range.end_time"
        :picker-options="pickerOptions"
        type="datetime"
        format="yyyy/MM/dd"
        size="small"
        class="p-2 border rounded-md shadow-sm"
        placeholder="Дуусах огноог сонгоно уу"
      />
      <el-button size="small" type="info" @click="getDashboardData" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600">
        Хайх
      </el-button>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Нийт шилжүүлсэн</h3>
        <h1 class="text-2xl font-bold text-green-600">{{ totalTransfered.amount }}</h1>
      </el-card>
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Төлбөр буугаагүй</h3>
        <h1 class="text-2xl font-bold text-green-600">{{ clientConfirmed.amount }}</h1>
      </el-card>
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Автоматаар баталгаажсан</h3>
        <h1 class="text-2xl font-bold text-green-600">{{ autoConfirmed.amount }}</h1>
      </el-card>
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Нийт шилжүүлсэн</h3>
        <h1 class="text-2xl font-bold text-green-600">{{ totalTransfered.amount }}</h1>
      </el-card>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Coming soon</h3>
        <h1 class="text-2xl font-bold text-green-600">0</h1>
      </el-card>
      <el-card class="p-4 shadow rounded-lg">
        <h3 class="text-lg font-semibold text-gray-700">Coming soon</h3>
        <h1 class="text-2xl font-bold text-green-600">0</h1>
      </el-card>
    </div>
  </div>
</template>

<script>
import service from '@/helpers/partnerServices.js'
import { showNotification } from '@/helpers/helper.js'
import calculate from '../assets/calculate.png'
import toktok from '../assets/toktok.png'
import dayjs from 'dayjs'
export default {
  created () {
    this.getDashboardData()
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,
      startDate: '',
      endDate: '',
      tableData: [],
      range: {
        start_time: dayjs().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        end_time: dayjs().format('YYYY-MM-DD')
      },
      calculate: calculate,
      toktok: toktok,
      totalTransfered: {},
      totalCreated: {},
      autoConfirmed: {},
      clientConfirmed: {}
    }
  },
  methods: {
    getDashboardData () {
      if (this.range.start_time > this.range.end_time) {
        showNotification('info', 'Таны сонгосон хугацаагаар хайх боломжгүй')
        return false
      }
      this.loading = true
      const payload = {
        start_time: dayjs(this.range.start_time).format('YYYY-MM-DD'),
        end_time: dayjs(this.range.end_time).format('YYYY-MM-DD')
      }
      service.getDashboard(payload).then((res) => {
        if (res.data.status === 'success') {
          this.tableData = res.data.data
          const statusMap = {
            100: 'totalTransfered',
            10: 'totalCreated',
            22: 'autoConfirmed',
            21: 'clientConfirmed'
          }

          res.data.data.map(el => {
            const key = statusMap[el.status_code]
            if (key) {
              this[key] = el
            }
          })
        } else {
          this.$message.error('Алдаа, нийт жагсаалт татахад алдаа гарлаа.')
        }
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.header {
  float: right;
}
.image {
    width: 100%;
    display: block;
  }
  .button {
    align-items: center;
    font-size: 0.8vw;
  }
  .card {
    width: 60%;
    margin-left: 20%;
  }
</style>
